import { mapActions, mapMutations, mapState } from 'vuex'

export const previewMixin = {
  computed: {
    ...mapState({
      canLivePreview: (state) => state.creative.template.canLivePreview,
      templateConfig: (state) => state.creative.template.templateConfig || {},
      previewer: (state) => state.creative.template.previewer,
      validateList: (state) => state.creative.template.validateList,
      previewGroup: (state) => state.creative.template.previewGroup,
      preparingPreview: (state) => state.creative.template.preparingPreview,
    }),

    canLivePreviewAndGameReady() {
      return this.canLivePreview && this.previewer.gameReady
    },
  },

  methods: {
    ...mapActions({
      livePreview: 'creative/template/livePreview',
      saveTemplate: 'creative/template/saveTemplate',
      previewActiveScene: 'creative/template/previewer/previewActiveScene',
      livePreviewResources: 'creative/template/livePreviewResources',
      livePreviewJsonConfig: 'creative/template/livePreviewJsonConfig',
      navigateToStartScene: 'creative/template/navigateToStartScene',
    }),

    ...mapMutations({
      emptyValidator: 'creative/template/emptyValidator',
      updatePreparingPreview: 'creative/template/updatePreparingPreview',
    }),

    async validate() {
      if (this.validateList.length > 0) {
        try {
          const valid = await Promise.all(
            this.validateList
              .filter((item) => item && typeof item.validate === 'function')
              .map((item) => item.validate()),
          )

          if (valid.every((item) => item === true)) {
            this.emptyValidator()
            return true
          }
          this.validateFail()
        } catch (e) {
          console.error(e)
          this.$gtag &&
            this.$gtag.exception({
              description: e,
              fatal: false,
            })
          this.validateFail(e.message)
          return false
        }
      } else {
        this.emptyValidator()
        return true
      }
      return true
    },

    validateFail(message) {
      this.$message.error(
        message || this.$t('playTurbo.creative.templateMixin.error'),
      )
    },

    switchScene(scene) {
      if (this.previewer.gameReady) {
        this.previewActiveScene(scene)
      } else {
        this.$message.info(this.$t('playTurbo.custom.previewer.loadingText'))
      }
    },

    /**
     * 预览处理实时预览与普通预览
     */
    async preview() {
      const valid = await this.validate()

      if (!valid) return

      if (this.canLivePreviewAndGameReady) {
        this.livePreviewResources()
        this.livePreviewJsonConfig()
      } else {
        await this.previewAfterPackaging()
      }
    },

    /**
     * previewAfterPackaging 打包后预览，不支持实时预览的脚本都使用该预览方式
     */
    async previewAfterPackaging() {
      try {
        await this.$store.dispatch('creative/template/saveTemplate')
      } catch (e) {
        console.error(e)
      }
    },
  },
}
